import { css, styled } from "styled-components";

import { ButtonType } from "./types";

const ButtonContainer = styled.button<{ $type: ButtonType; $color?: string; $loading: boolean }>`
  gap: 0.5rem;
  display: flex;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 600;
  text-align: center;
  line-height: normal;
  align-items: center;
  padding: 0.75rem 1rem;
  justify-content: center;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.manrope};

  transition: ${({ theme }) => theme.transitions.hover};

  &:active {
    box-shadow: 0px 0px 0px 0px ${({ theme }) => theme.colors.black};
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
    &:hover {
      box-shadow: 0px 0px 0px 0px ${({ theme }) => theme.colors.black};
    }
  }

  ${({ $type, $color, theme, $loading }) => {
    switch ($type) {
      case "outlined":
        return css`
          border-radius: 1.5rem;
          background: transparent;
          padding: 0.75rem 1.5rem;
          color: ${$color || theme.colors.black};
          border: 1px solid ${$color || theme.colors.black};
        `;
      case "black":
        return css`
          border: none;
          border-radius: 2rem;
          color: ${theme.colors.white};
          background: ${theme.colors.black};
        `;
      case "news":
        return css`
          transition:
            box-shadow 0.2s ease 0s,
            transform 0.2s ease 0s;
          border-radius: 1rem;
          border: 1px solid ${theme.colors.black};
          background-color: ${theme.colors.pink};
          box-shadow: 4px 4px 0px 0px ${theme.colors.black};

          &:active {
            transform: translate(4px, 4px);
            box-shadow: 0px 0px 0px 0px ${theme.colors.black};
          }
        `;
      case "secondary": {
        return css`
          transition:
            box-shadow 0.2s ease 0s,
            transform 0.2s ease 0s;
          border-radius: 1rem;
          border: 1px solid ${theme.colors.black};
          background-color: ${theme.colors.button.secondary.bg};
          box-shadow: 4px 4px 0px 0px ${theme.colors.button.secondary.boxShadow};

          &:active {
            transform: translate(4px, 4px);
            box-shadow: 0px 0px 0px 0px ${theme.colors.button.secondary.boxShadow};
          }

          &:disabled {
            transform: translate(4px, 4px);
            box-shadow: 0px 0px 0px 0px ${theme.colors.button.secondary.boxShadow};
          }
        `;
      }
      default:
        return css`
          transition:
            box-shadow 0.2s ease 0s,
            transform 0.2s ease 0s;
          border-radius: 1rem;
          border: 1px solid ${theme.colors.black};
          background-color: ${theme.colors.orange};
          box-shadow: 4px 4px 0px 0px ${theme.colors.black};

          &:active {
            transform: translate(4px, 4px);
            box-shadow: 0px 0px 0px 0px ${theme.colors.black};
          }

          /* TODO: loading */
          ${$loading
            ? css`
                &:disabled {
                  transform: translate(4px, 4px);
                  box-shadow: 0px 0px 0px 0px ${theme.colors.black};
                }
              `
            : css`
                &:disabled {
                  opacity: 1;
                  background-color: ${theme.colors.button.default.disabledBg};
                  color: ${theme.colors.button.default.disabledText};
                  transform: translate(0px, 0px);
                  box-shadow: 4px 4px 0px 0px ${theme.colors.black};
                }
              `}
        `;
    }
  }}
`;

export default {
  ButtonContainer,
};
